import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getTeamMembers } from '../services/wordpress';
import { NewsItem } from '../types';
import { Loader2, ArrowRight } from 'lucide-react';
import { safeHTML } from '../utils/safeHTML';
import './TeamPage.css';
import { useNavigate } from 'react-router-dom';

const TeamPage: React.FC = () => {
  const navigate = useNavigate();
  const [team, setTeam] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTeam() {
      const data = await getTeamMembers();
      setTeam(data);
      setLoading(false);
    }
    fetchTeam();
  }, []);

    return (
    <div className="TeamPage_page">
      <Helmet>
        <title>Susunan Pengurus - Lakpesdam PBNU</title>
        <meta name="description" content="Struktur organisasi dan susunan pengurus Lembaga Kajian dan Pengembangan SDM PBNU." />
        <meta property="og:title" content="Susunan Pengurus - Lakpesdam PBNU" />
        <meta property="og:description" content="Struktur organisasi dan susunan pengurus Lakpesdam PBNU." />
        <meta property="og:image" content="https://lakpesdam.or.id/assets/og-image.png" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="TeamPage_decor1"></div>
      <div className="TeamPage_decor2"></div>
      
      <div className="container relative z-10">
        <div className="TeamPage_header animate-fade-up">
          <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1.5 rounded-full text-sm font-bold mb-4 tracking-wide border border-emerald-200">
            PENGURUS LAKPESDAM PBNU
          </div>
          <h1 className="TeamPage_title">Struktur Organisasi & Tim Ahli</h1>
          <p className="TeamPage_subtitle">
            Mengenal lebih dekat para pemikir dan penggerak di balik visi besar Lakpesdam PBNU dalam pengembangan sumber daya manusia Nahdlatul Ulama.
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="animate-spin text-emerald-700" size={48} />
          </div>
        ) : (
          <div className="TeamPage_grid">
            {team.length === 0 ? (
              <div className="col-span-full text-center py-10 text-slate-500 bg-white/50 backdrop-blur-md rounded-2xl border border-white p-8">
                Data tim belum tersedia.
              </div>
            ) : (
              team.map((member, index) => (
                <div 
                  key={member.id} 
                  className="TeamPage_card animate-fade-up" 
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="TeamPage_imgWrapper">
                    <img
                      src={member.imageUrl}
                      alt={member.title}
                      className="TeamPage_img"
                      loading="lazy"
                      width="400"
                      height="400"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22400%22%20height%3D%22400%22%20viewBox%3D%220%200%20400%20400%22%3E%3Crect%20fill%3D%22%23064e3b%22%20width%3D%22400%22%20height%3D%22400%22%2F%3E%3Ctext%20fill%3D%22%23ffffff%22%20font-family%3D%22sans-serif%22%20font-size%3D%2260%22%20dy%3D%2220%22%20font-weight%3D%22bold%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20text-anchor%3D%22middle%22%3EL%3C%2Ftext%3E%3C%2Fsvg%3E';
                      }}
                    />
                    <div className="TeamPage_imgOverlay"></div>
                  </div>
                  <div className="TeamPage_info">
                    {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                    <h3 className="TeamPage_name" {...safeHTML(member.title)} aria-label={member.title.replace(/<[^>]+>/g, '').trim()}></h3>
                    <div className="TeamPage_roleContainer">
                      <span className="TeamPage_role">{member.role || 'Pengurus'}</span>
                    </div>
                    <div className="TeamPage_actions">
                      <button
                        onClick={() => navigate(`/${member.slug || member.id}`)}
                        className="TeamPage_btn group"
                      >
                        Lihat Profil <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamPage;
